import { render, staticRenderFns } from "./ItemCarousel.vue?vue&type=template&id=79c87816&scoped=true&"
import script from "./ItemCarousel.vue?vue&type=script&lang=js&"
export * from "./ItemCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ItemCarousel.vue?vue&type=style&index=0&id=79c87816&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c87816",
  null
  
)

export default component.exports